export default __webpack_public_path__ + "static/media/10.6d6bb5a8.jpg";